<?php

\Core\View::$template = function () {
    $html = '
        <form id="pharaoh_form">
            <header class="col-sm-12 navbar">
                <div class="col-sm-8">
                    <h1>Register with Video Interviews</h1>
                </div>
                <div class="col-sm-2">
                    <div id="user-menu" class="user-menu"></div>
                    <div id="settings-menu" class="settings-menu"></div>
                </div>
            </header>
            <div class="col-sm-12">
                <div class="col-sm-6">
                    <h2>Username</h2>
                </div> 
                <div class="col-sm-6">
                    <input type="text" name="username" id="username" /> 
                </div> 
            </div> 
            <div class="col-sm-12">
                <div class="col-sm-6">
                    <h2>Email</h2>
                </div> 
                <div class="col-sm-6">
                    <input type="email" name="email" id="email" /> 
                </div> 
            </div> 
            <div class="col-sm-12">
                <div class="col-sm-6">
                    <h2>Password</h2>
                </div> 
                <div class="col-sm-6">
                    <input type="password" name="pass" id="pass" />
                </div> 
            </div>  
            <div class="col-sm-12">
                <div class="col-sm-6">
                    <h2>Password Confirmation</h2>
                </div> 
                <div class="col-sm-6">
                    <input type="password" name="pass_conf" id="pass_conf" />
                </div> 
            </div> ';

    $html = $html . '    <div class="col-sm-12">';
    $html = $html . '        <span id="perform-registration" class="btn btn-success">Register</span>';
    $html = $html . '    </div>';
    $html = $html . '    <div class="col-sm-12">';
    $html = $html . '        <span id="cancel-registration" class="btn btn-warning">Cancel</span>';
    $html = $html . '    </div>';
    $html = $html . '</form>';
    return $html;

};


// WEBPACK FOOTER //
// app/Register/View/Register.php